import React, {useEffect, useState} from "react";
import {Trans, useTranslation} from "react-i18next";
import {useCheckoutContext} from "../../CheckoutContextProvider/CheckoutContextProvider";
import {useCustomerSelector} from "../../../../store";
import Checkbox from "../../../lib/form/Checkbox/Checkbox";

const SummaryNewsletter: React.FC = () => {
  const {t} = useTranslation();
  const {customer} = useCustomerSelector();
  const {checkout} = useCheckoutContext();
  const [isChecked, setIsChecked] = useState<boolean>(false);

  if (customer.newsletterFlag) {
    return null;
  }

  useEffect(() => {
    if (checkout.hasNewsletter !== isChecked) {
      void checkout.put({hasNewsletter: isChecked});
    }
  }, [isChecked]);

  return (
    <div className="checkout-summary-option">
      <Checkbox
        wrapperClassName="checkbox__wrapper"
        className="checkbox--large"
        checked={isChecked}
        color={"green"}
        onChange={() => setIsChecked(!isChecked)}
      >
        <Trans
          i18nKey="newsletter.subscribeAgreement"
          ns="translations"
          components={{
            a: <a href={t("url.privacyLink")} target="_blank" rel="noreferrer" />,
            s: <strong />,
          }}
        />
      </Checkbox>
    </div>
  );
};

export default SummaryNewsletter;
